import { useRef } from 'react';
import { motion, useInView } from 'framer-motion';

export default function AboutSection() {
  const ref = useRef<HTMLDivElement>(null);
  const isInView = useInView(ref, { once: true, margin: '-100px' });

  return (
    <section id="sobre" className="relative py-24 md:py-32 lg:py-40 bg-dark-950 overflow-hidden">
      <div className="max-w-[1440px] mx-auto px-6 md:px-10 lg:px-16">
        <div ref={ref} className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20">
          <motion.div
            initial={{ opacity: 0, x: -60 }}
            animate={isInView ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 1, ease: [0.4, 0, 0.2, 1] }}
            className="w-full lg:w-1/2"
          >
            <div className="relative overflow-hidden rounded-lg">
              <motion.div
                initial={{ scale: 1.15 }}
                animate={isInView ? { scale: 1 } : {}}
                transition={{ duration: 1.5, ease: [0.4, 0, 0.2, 1] }}
              >
                <img
                  src="https://storage.helloreaddy.io/project_files/1fff4f2a-b372-4b40-8698-6f714b3b8587/f8ccb2b3-3d8c-4b0a-bcea-53ae7404f34e_compressed_Captura-de-tela-2026-07-30-183623.webp"
                  alt="Detalhes da barbearia - navalha e toalha quente"
                  className="w-full h-[500px] md:h-[600px] lg:h-[700px] object-cover object-center"
                />
              </motion.div>
              <div className="absolute inset-0 bg-gradient-to-t from-dark-950/60 to-transparent"></div>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 60 }}
            animate={isInView ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 1, ease: [0.4, 0, 0.2, 1], delay: 0.2 }}
            className="w-full lg:w-1/2"
          >
            <motion.span
              initial={{ opacity: 0, y: 20 }}
              animate={isInView ? { opacity: 1, y: 0 } : {}}
              transition={{ delay: 0.3 }}
              className="text-premium-400 text-xs tracking-[0.3em] uppercase font-medium"
            >
              Uma Barbearia Feita Para Homens
            </motion.span>

            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-white mt-4 mb-6 leading-tight">
              Onde tradição,{' '}
              <span className="text-gradient-gold">técnica e estilo</span>
              <br />
              se encontram.
            </h2>

            <motion.div
              initial={{ width: 0 }}
              animate={isInView ? { width: '80px' } : {}}
              transition={{ delay: 0.5, duration: 0.8 }}
              className="h-[1px] bg-premium-500 mb-8"
            ></motion.div>

            <div className="space-y-5 text-white/60 leading-relaxed text-sm md:text-base font-light">
              <motion.p
                initial={{ opacity: 0, y: 20 }}
                animate={isInView ? { opacity: 1, y: 0 } : {}}
                transition={{ delay: 0.6 }}
              >
                A Tal Pai, Tal Filho nasceu do desejo de resgatar a essência da barbearia clássica, 
                onde cada corte é uma experiência e cada cliente é tratado com a atenção que merece.
              </motion.p>
              <motion.p
                initial={{ opacity: 0, y: 20 }}
                animate={isInView ? { opacity: 1, y: 0 } : {}}
                transition={{ delay: 0.8 }}
              >
                Nosso espaço foi projetado para ser um refúgio masculino em Fortaleza. Aqui, tradição e modernidade 
                se encontram em um ambiente que combina madeira nobre, couro, aço escovado e iluminação pensada 
                para criar a atmosfera perfeita.
              </motion.p>
              <motion.p
                initial={{ opacity: 0, y: 20 }}
                animate={isInView ? { opacity: 1, y: 0 } : {}}
                transition={{ delay: 1 }}
              >
                Mais do que uma barbearia, somos um clube para homens que entendem que cuidar da aparência 
                é um ato de respeito próprio. Oferecemos café espresso, whisky 12 anos e cerveja artesanal 
                para tornar cada visita uma pausa merecida na rotina.
              </motion.p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}